import concat from 'lodash/concat';

import {
  GET_ACTIVE_BUSINESSES,
  GET_ACTIVE_BUSINESSES_SUCCESS,
  SET_BUSINESS,
} from '../types/business';
import { updateStates } from '@/utils/reducer';

const initState = {
  isLoading: false,
  items: [],
  error: '',
  activeList: [],
  metadata: {},
  item: {},
  selectedBusiness: null,
};

const reducer = (state = initState, action) => {
  const { type, data, metadata, business } = action;
  switch (type) {
    case GET_ACTIVE_BUSINESSES:
      return updateStates(state, {
        isLoading: true,
      });
    case GET_ACTIVE_BUSINESSES_SUCCESS:
      return updateStates(state, {
        isLoading: false,
        activeList: concat(state.activeList, data),
        metadata,
      });
    case SET_BUSINESS:
      return updateStates(state, {
        item: business,
      });
    default:
      return state;
  }
};

export default reducer;
